"use strict";
/* Generated from:
 * ap-northeast-1 (https://d33vqc0rt9ld30.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-2 (https://d1ane3fvebulky.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-south-1 (https://d2senuesg1djtx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-1 (https://doigdx0kgq9el.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-2 (https://d2stg8d246z9di.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-central-1 (https://d1mta8qj7i28i2.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-1 (https://d3teyb21fexa9r.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * sa-east-1 (https://d3c9jyj3w509b0.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-1 (https://d1uauaxba7bl26.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-2 (https://d201a2mn26r7lk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = require("../resource");
class HlsInputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HlsInputSettings = HlsInputSettings;
class DvbSubDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DvbSubDestinationSettings = DvbSubDestinationSettings;
class Rec709Settings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Rec709Settings = Rec709Settings;
class VideoCodecSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VideoCodecSettings = VideoCodecSettings;
class HlsSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HlsSettings = HlsSettings;
class FrameCaptureSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.FrameCaptureSettings = FrameCaptureSettings;
class MotionGraphicsSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MotionGraphicsSettings = MotionGraphicsSettings;
class FrameCaptureCdnSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.FrameCaptureCdnSettings = FrameCaptureCdnSettings;
class InputLossBehavior {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InputLossBehavior = InputLossBehavior;
class MultiplexProgramChannelDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MultiplexProgramChannelDestinationSettings = MultiplexProgramChannelDestinationSettings;
class HlsCdnSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HlsCdnSettings = HlsCdnSettings;
class HlsOutputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HlsOutputSettings = HlsOutputSettings;
class EmbeddedPlusScte20DestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.EmbeddedPlusScte20DestinationSettings = EmbeddedPlusScte20DestinationSettings;
class FrameCaptureS3Settings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.FrameCaptureS3Settings = FrameCaptureS3Settings;
class ArchiveCdnSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ArchiveCdnSettings = ArchiveCdnSettings;
class Scte27SourceSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Scte27SourceSettings = Scte27SourceSettings;
class AudioTrackSelection {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AudioTrackSelection = AudioTrackSelection;
class EbuTtDDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.EbuTtDDestinationSettings = EbuTtDDestinationSettings;
class VideoSelectorPid {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VideoSelectorPid = VideoSelectorPid;
class FailoverCondition {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.FailoverCondition = FailoverCondition;
class Hdr10Settings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Hdr10Settings = Hdr10Settings;
class StaticKeySettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.StaticKeySettings = StaticKeySettings;
class InputLocation {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InputLocation = InputLocation;
class AudioLanguageSelection {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AudioLanguageSelection = AudioLanguageSelection;
class CaptionRectangle {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CaptionRectangle = CaptionRectangle;
class ArchiveS3Settings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ArchiveS3Settings = ArchiveS3Settings;
class SmpteTtDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SmpteTtDestinationSettings = SmpteTtDestinationSettings;
class AribSourceSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AribSourceSettings = AribSourceSettings;
class Mp2Settings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Mp2Settings = Mp2Settings;
class AudioSilenceFailoverSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AudioSilenceFailoverSettings = AudioSilenceFailoverSettings;
class Fmp4HlsSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Fmp4HlsSettings = Fmp4HlsSettings;
class Scte35SpliceInsert {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Scte35SpliceInsert = Scte35SpliceInsert;
class AudioChannelMapping {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AudioChannelMapping = AudioChannelMapping;
class FeatureActivations {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.FeatureActivations = FeatureActivations;
class OutputGroup {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.OutputGroup = OutputGroup;
class UdpOutputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.UdpOutputSettings = UdpOutputSettings;
class Ac3Settings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Ac3Settings = Ac3Settings;
class Eac3Settings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Eac3Settings = Eac3Settings;
class MediaPackageOutputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MediaPackageOutputSettings = MediaPackageOutputSettings;
class Rec601Settings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Rec601Settings = Rec601Settings;
class H264Settings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.H264Settings = H264Settings;
class H264FilterSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.H264FilterSettings = H264FilterSettings;
class FailoverConditionSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.FailoverConditionSettings = FailoverConditionSettings;
class Mpeg2Settings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Mpeg2Settings = Mpeg2Settings;
class AudioSelectorSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AudioSelectorSettings = AudioSelectorSettings;
class UdpContainerSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.UdpContainerSettings = UdpContainerSettings;
class TimecodeConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TimecodeConfig = TimecodeConfig;
class VideoSelector {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VideoSelector = VideoSelector;
class DvbTdtSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DvbTdtSettings = DvbTdtSettings;
class HlsGroupSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HlsGroupSettings = HlsGroupSettings;
class OutputDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.OutputDestinationSettings = OutputDestinationSettings;
class AvailConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AvailConfiguration = AvailConfiguration;
class TeletextDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TeletextDestinationSettings = TeletextDestinationSettings;
class H265Settings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.H265Settings = H265Settings;
class AudioCodecSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AudioCodecSettings = AudioCodecSettings;
class DvbNitSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DvbNitSettings = DvbNitSettings;
class WebvttDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.WebvttDestinationSettings = WebvttDestinationSettings;
class AacSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AacSettings = AacSettings;
class Scte35TimeSignalApos {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Scte35TimeSignalApos = Scte35TimeSignalApos;
class FecOutputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.FecOutputSettings = FecOutputSettings;
class OutputDestination {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.OutputDestination = OutputDestination;
class AncillarySourceSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AncillarySourceSettings = AncillarySourceSettings;
class Mpeg2FilterSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Mpeg2FilterSettings = Mpeg2FilterSettings;
class CaptionSelector {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CaptionSelector = CaptionSelector;
class VideoBlackFailoverSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VideoBlackFailoverSettings = VideoBlackFailoverSettings;
class RtmpOutputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RtmpOutputSettings = RtmpOutputSettings;
class RtmpCaptionInfoDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RtmpCaptionInfoDestinationSettings = RtmpCaptionInfoDestinationSettings;
class TtmlDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TtmlDestinationSettings = TtmlDestinationSettings;
class M2tsSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.M2tsSettings = M2tsSettings;
class HlsWebdavSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HlsWebdavSettings = HlsWebdavSettings;
class NielsenConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.NielsenConfiguration = NielsenConfiguration;
class GlobalConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.GlobalConfiguration = GlobalConfiguration;
class MediaPackageOutputDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MediaPackageOutputDestinationSettings = MediaPackageOutputDestinationSettings;
class AudioOnlyHlsSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AudioOnlyHlsSettings = AudioOnlyHlsSettings;
class OutputLocationRef {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.OutputLocationRef = OutputLocationRef;
class Scte27DestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Scte27DestinationSettings = Scte27DestinationSettings;
class AutomaticInputFailoverSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AutomaticInputFailoverSettings = AutomaticInputFailoverSettings;
class FrameCaptureGroupSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.FrameCaptureGroupSettings = FrameCaptureGroupSettings;
class ArchiveOutputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ArchiveOutputSettings = ArchiveOutputSettings;
class ArchiveGroupSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ArchiveGroupSettings = ArchiveGroupSettings;
class RawSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RawSettings = RawSettings;
class DvbSdtSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DvbSdtSettings = DvbSdtSettings;
class VideoSelectorProgramId {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VideoSelectorProgramId = VideoSelectorProgramId;
class InputAttachment {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InputAttachment = InputAttachment;
class InputChannelLevel {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InputChannelLevel = InputChannelLevel;
class StandardHlsSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.StandardHlsSettings = StandardHlsSettings;
class PassThroughSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.PassThroughSettings = PassThroughSettings;
class ArchiveContainerSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ArchiveContainerSettings = ArchiveContainerSettings;
class EmbeddedSourceSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.EmbeddedSourceSettings = EmbeddedSourceSettings;
class InputSpecification {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InputSpecification = InputSpecification;
class FrameCaptureOutputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.FrameCaptureOutputSettings = FrameCaptureOutputSettings;
class EncoderSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.EncoderSettings = EncoderSettings;
class AvailSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AvailSettings = AvailSettings;
class H264ColorSpaceSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.H264ColorSpaceSettings = H264ColorSpaceSettings;
class MediaPackageGroupSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MediaPackageGroupSettings = MediaPackageGroupSettings;
class MultiplexOutputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MultiplexOutputSettings = MultiplexOutputSettings;
class H265ColorSpaceSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.H265ColorSpaceSettings = H265ColorSpaceSettings;
class EmbeddedDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.EmbeddedDestinationSettings = EmbeddedDestinationSettings;
class AvailBlanking {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AvailBlanking = AvailBlanking;
class InputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InputSettings = InputSettings;
class AudioNormalizationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AudioNormalizationSettings = AudioNormalizationSettings;
class MultiplexGroupSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MultiplexGroupSettings = MultiplexGroupSettings;
class InputLossFailoverSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InputLossFailoverSettings = InputLossFailoverSettings;
class AudioSelector {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AudioSelector = AudioSelector;
class AudioPidSelection {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AudioPidSelection = AudioPidSelection;
class CaptionLanguageMapping {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CaptionLanguageMapping = CaptionLanguageMapping;
class DvbSubSourceSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DvbSubSourceSettings = DvbSubSourceSettings;
class CaptionSelectorSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CaptionSelectorSettings = CaptionSelectorSettings;
class VideoSelectorSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VideoSelectorSettings = VideoSelectorSettings;
class VpcOutputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VpcOutputSettings = VpcOutputSettings;
class TeletextSourceSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TeletextSourceSettings = TeletextSourceSettings;
class CaptionDescription {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CaptionDescription = CaptionDescription;
class MotionGraphicsConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MotionGraphicsConfiguration = MotionGraphicsConfiguration;
class VideoSelectorColorSpaceSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VideoSelectorColorSpaceSettings = VideoSelectorColorSpaceSettings;
class Output {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Output = Output;
class NetworkInputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.NetworkInputSettings = NetworkInputSettings;
class H265FilterSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.H265FilterSettings = H265FilterSettings;
class HlsBasicPutSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HlsBasicPutSettings = HlsBasicPutSettings;
class Scte20PlusEmbeddedDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Scte20PlusEmbeddedDestinationSettings = Scte20PlusEmbeddedDestinationSettings;
class Scte20SourceSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Scte20SourceSettings = Scte20SourceSettings;
class AudioTrack {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AudioTrack = AudioTrack;
class AudioDescription {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AudioDescription = AudioDescription;
class BurnInDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.BurnInDestinationSettings = BurnInDestinationSettings;
class RtmpGroupSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RtmpGroupSettings = RtmpGroupSettings;
class MsSmoothOutputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MsSmoothOutputSettings = MsSmoothOutputSettings;
class CaptionDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CaptionDestinationSettings = CaptionDestinationSettings;
class MsSmoothGroupSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MsSmoothGroupSettings = MsSmoothGroupSettings;
class WavSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.WavSettings = WavSettings;
class KeyProviderSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.KeyProviderSettings = KeyProviderSettings;
class CdiInputSpecification {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CdiInputSpecification = CdiInputSpecification;
class OutputGroupSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.OutputGroupSettings = OutputGroupSettings;
class HtmlMotionGraphicsSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HtmlMotionGraphicsSettings = HtmlMotionGraphicsSettings;
class OutputSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.OutputSettings = OutputSettings;
class HlsS3Settings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HlsS3Settings = HlsS3Settings;
class VideoDescription {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VideoDescription = VideoDescription;
class BlackoutSlate {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.BlackoutSlate = BlackoutSlate;
class ColorSpacePassthroughSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ColorSpacePassthroughSettings = ColorSpacePassthroughSettings;
class HlsMediaStoreSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HlsMediaStoreSettings = HlsMediaStoreSettings;
class M3u8Settings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.M3u8Settings = M3u8Settings;
class AribDestinationSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AribDestinationSettings = AribDestinationSettings;
class UdpGroupSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.UdpGroupSettings = UdpGroupSettings;
class FrameCaptureHlsSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.FrameCaptureHlsSettings = FrameCaptureHlsSettings;
class RemixSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RemixSettings = RemixSettings;
class TemporalFilterSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TemporalFilterSettings = TemporalFilterSettings;
class HlsAkamaiSettings {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HlsAkamaiSettings = HlsAkamaiSettings;
class Channel extends resource_1.ResourceBase {
    constructor(properties) {
        super('AWS::MediaLive::Channel', properties || {});
    }
}
exports.default = Channel;
Channel.HlsInputSettings = HlsInputSettings;
Channel.DvbSubDestinationSettings = DvbSubDestinationSettings;
Channel.Rec709Settings = Rec709Settings;
Channel.VideoCodecSettings = VideoCodecSettings;
Channel.HlsSettings = HlsSettings;
Channel.FrameCaptureSettings = FrameCaptureSettings;
Channel.MotionGraphicsSettings = MotionGraphicsSettings;
Channel.FrameCaptureCdnSettings = FrameCaptureCdnSettings;
Channel.InputLossBehavior = InputLossBehavior;
Channel.MultiplexProgramChannelDestinationSettings = MultiplexProgramChannelDestinationSettings;
Channel.HlsCdnSettings = HlsCdnSettings;
Channel.HlsOutputSettings = HlsOutputSettings;
Channel.EmbeddedPlusScte20DestinationSettings = EmbeddedPlusScte20DestinationSettings;
Channel.FrameCaptureS3Settings = FrameCaptureS3Settings;
Channel.ArchiveCdnSettings = ArchiveCdnSettings;
Channel.Scte27SourceSettings = Scte27SourceSettings;
Channel.AudioTrackSelection = AudioTrackSelection;
Channel.EbuTtDDestinationSettings = EbuTtDDestinationSettings;
Channel.VideoSelectorPid = VideoSelectorPid;
Channel.FailoverCondition = FailoverCondition;
Channel.Hdr10Settings = Hdr10Settings;
Channel.StaticKeySettings = StaticKeySettings;
Channel.InputLocation = InputLocation;
Channel.AudioLanguageSelection = AudioLanguageSelection;
Channel.CaptionRectangle = CaptionRectangle;
Channel.ArchiveS3Settings = ArchiveS3Settings;
Channel.SmpteTtDestinationSettings = SmpteTtDestinationSettings;
Channel.AribSourceSettings = AribSourceSettings;
Channel.Mp2Settings = Mp2Settings;
Channel.AudioSilenceFailoverSettings = AudioSilenceFailoverSettings;
Channel.Fmp4HlsSettings = Fmp4HlsSettings;
Channel.Scte35SpliceInsert = Scte35SpliceInsert;
Channel.AudioChannelMapping = AudioChannelMapping;
Channel.FeatureActivations = FeatureActivations;
Channel.OutputGroup = OutputGroup;
Channel.UdpOutputSettings = UdpOutputSettings;
Channel.Ac3Settings = Ac3Settings;
Channel.Eac3Settings = Eac3Settings;
Channel.MediaPackageOutputSettings = MediaPackageOutputSettings;
Channel.Rec601Settings = Rec601Settings;
Channel.H264Settings = H264Settings;
Channel.H264FilterSettings = H264FilterSettings;
Channel.FailoverConditionSettings = FailoverConditionSettings;
Channel.Mpeg2Settings = Mpeg2Settings;
Channel.AudioSelectorSettings = AudioSelectorSettings;
Channel.UdpContainerSettings = UdpContainerSettings;
Channel.TimecodeConfig = TimecodeConfig;
Channel.VideoSelector = VideoSelector;
Channel.DvbTdtSettings = DvbTdtSettings;
Channel.HlsGroupSettings = HlsGroupSettings;
Channel.OutputDestinationSettings = OutputDestinationSettings;
Channel.AvailConfiguration = AvailConfiguration;
Channel.TeletextDestinationSettings = TeletextDestinationSettings;
Channel.H265Settings = H265Settings;
Channel.AudioCodecSettings = AudioCodecSettings;
Channel.DvbNitSettings = DvbNitSettings;
Channel.WebvttDestinationSettings = WebvttDestinationSettings;
Channel.AacSettings = AacSettings;
Channel.Scte35TimeSignalApos = Scte35TimeSignalApos;
Channel.FecOutputSettings = FecOutputSettings;
Channel.OutputDestination = OutputDestination;
Channel.AncillarySourceSettings = AncillarySourceSettings;
Channel.Mpeg2FilterSettings = Mpeg2FilterSettings;
Channel.CaptionSelector = CaptionSelector;
Channel.VideoBlackFailoverSettings = VideoBlackFailoverSettings;
Channel.RtmpOutputSettings = RtmpOutputSettings;
Channel.RtmpCaptionInfoDestinationSettings = RtmpCaptionInfoDestinationSettings;
Channel.TtmlDestinationSettings = TtmlDestinationSettings;
Channel.M2tsSettings = M2tsSettings;
Channel.HlsWebdavSettings = HlsWebdavSettings;
Channel.NielsenConfiguration = NielsenConfiguration;
Channel.GlobalConfiguration = GlobalConfiguration;
Channel.MediaPackageOutputDestinationSettings = MediaPackageOutputDestinationSettings;
Channel.AudioOnlyHlsSettings = AudioOnlyHlsSettings;
Channel.OutputLocationRef = OutputLocationRef;
Channel.Scte27DestinationSettings = Scte27DestinationSettings;
Channel.AutomaticInputFailoverSettings = AutomaticInputFailoverSettings;
Channel.FrameCaptureGroupSettings = FrameCaptureGroupSettings;
Channel.ArchiveOutputSettings = ArchiveOutputSettings;
Channel.ArchiveGroupSettings = ArchiveGroupSettings;
Channel.RawSettings = RawSettings;
Channel.DvbSdtSettings = DvbSdtSettings;
Channel.VideoSelectorProgramId = VideoSelectorProgramId;
Channel.InputAttachment = InputAttachment;
Channel.InputChannelLevel = InputChannelLevel;
Channel.StandardHlsSettings = StandardHlsSettings;
Channel.PassThroughSettings = PassThroughSettings;
Channel.ArchiveContainerSettings = ArchiveContainerSettings;
Channel.EmbeddedSourceSettings = EmbeddedSourceSettings;
Channel.InputSpecification = InputSpecification;
Channel.FrameCaptureOutputSettings = FrameCaptureOutputSettings;
Channel.EncoderSettings = EncoderSettings;
Channel.AvailSettings = AvailSettings;
Channel.H264ColorSpaceSettings = H264ColorSpaceSettings;
Channel.MediaPackageGroupSettings = MediaPackageGroupSettings;
Channel.MultiplexOutputSettings = MultiplexOutputSettings;
Channel.H265ColorSpaceSettings = H265ColorSpaceSettings;
Channel.EmbeddedDestinationSettings = EmbeddedDestinationSettings;
Channel.AvailBlanking = AvailBlanking;
Channel.InputSettings = InputSettings;
Channel.AudioNormalizationSettings = AudioNormalizationSettings;
Channel.MultiplexGroupSettings = MultiplexGroupSettings;
Channel.InputLossFailoverSettings = InputLossFailoverSettings;
Channel.AudioSelector = AudioSelector;
Channel.AudioPidSelection = AudioPidSelection;
Channel.CaptionLanguageMapping = CaptionLanguageMapping;
Channel.DvbSubSourceSettings = DvbSubSourceSettings;
Channel.CaptionSelectorSettings = CaptionSelectorSettings;
Channel.VideoSelectorSettings = VideoSelectorSettings;
Channel.VpcOutputSettings = VpcOutputSettings;
Channel.TeletextSourceSettings = TeletextSourceSettings;
Channel.CaptionDescription = CaptionDescription;
Channel.MotionGraphicsConfiguration = MotionGraphicsConfiguration;
Channel.VideoSelectorColorSpaceSettings = VideoSelectorColorSpaceSettings;
Channel.Output = Output;
Channel.NetworkInputSettings = NetworkInputSettings;
Channel.H265FilterSettings = H265FilterSettings;
Channel.HlsBasicPutSettings = HlsBasicPutSettings;
Channel.Scte20PlusEmbeddedDestinationSettings = Scte20PlusEmbeddedDestinationSettings;
Channel.Scte20SourceSettings = Scte20SourceSettings;
Channel.AudioTrack = AudioTrack;
Channel.AudioDescription = AudioDescription;
Channel.BurnInDestinationSettings = BurnInDestinationSettings;
Channel.RtmpGroupSettings = RtmpGroupSettings;
Channel.MsSmoothOutputSettings = MsSmoothOutputSettings;
Channel.CaptionDestinationSettings = CaptionDestinationSettings;
Channel.MsSmoothGroupSettings = MsSmoothGroupSettings;
Channel.WavSettings = WavSettings;
Channel.KeyProviderSettings = KeyProviderSettings;
Channel.CdiInputSpecification = CdiInputSpecification;
Channel.OutputGroupSettings = OutputGroupSettings;
Channel.HtmlMotionGraphicsSettings = HtmlMotionGraphicsSettings;
Channel.OutputSettings = OutputSettings;
Channel.HlsS3Settings = HlsS3Settings;
Channel.VideoDescription = VideoDescription;
Channel.BlackoutSlate = BlackoutSlate;
Channel.ColorSpacePassthroughSettings = ColorSpacePassthroughSettings;
Channel.HlsMediaStoreSettings = HlsMediaStoreSettings;
Channel.M3u8Settings = M3u8Settings;
Channel.AribDestinationSettings = AribDestinationSettings;
Channel.UdpGroupSettings = UdpGroupSettings;
Channel.FrameCaptureHlsSettings = FrameCaptureHlsSettings;
Channel.RemixSettings = RemixSettings;
Channel.TemporalFilterSettings = TemporalFilterSettings;
Channel.HlsAkamaiSettings = HlsAkamaiSettings;
